/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { PhoneIphoneOutlined } from "@mui/icons-material";
import { Stack, useTheme } from "@mui/material";
import { FC, type JSX } from "react";

import Typography from "./Typography";

interface ClickableContactNumberProps {
  phone: string;
}

const ClickableContactNumber: FC<ClickableContactNumberProps> = ({ phone }): JSX.Element | null => {
  const theme = useTheme();

  return (
    <Stack gap={1} flexDirection="row" alignItems="center">
      <PhoneIphoneOutlined color="disabled" />
      <Typography variant="body2" fontWeight={400} fontSize="1rem">
        <a href={`tel:${phone}`} style={{ color: theme.colors.primary600, textDecoration: "none" }}>
          {phone}
        </a>
      </Typography>
    </Stack>
  );
};

export default ClickableContactNumber;
